import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _cloneServiceOptionsAndVariantsRequest = {};
var _cloneServiceOptionsAndVariantsResponse = {};
var _createServiceOptionsAndVariantsRequest = {};
var _createServiceOptionsAndVariantsResponse = {};
var _deleteServiceOptionsAndVariantsRequest = {};
var _deleteServiceOptionsAndVariantsResponse = {};
var _getServiceOptionsAndVariantsByServiceIdRequest = {};
var _getServiceOptionsAndVariantsByServiceIdResponse = {};
var _getServiceOptionsAndVariantsRequest = {};
var _getServiceOptionsAndVariantsResponse = {};
var _queryServiceOptionsAndVariantsRequest = {};
var _queryServiceOptionsAndVariantsResponse = {};
var _updateServiceOptionsAndVariantsRequest = {
    mask: 'google.protobuf.FieldMask',
};
var _updateServiceOptionsAndVariantsResponse = {};
function resolveWixBookingsCatalogV1ServiceOptionsAndVariantsServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/v1/service-options-and-variants',
                destPath: '/v1/serviceOptionsAndVariants',
            },
            {
                srcPath: '/_api/v1/serviceOptionsAndVariants',
                destPath: '/v1/serviceOptionsAndVariants',
            },
            {
                srcPath: '/_api/bookings/v1/service-options-and-variants',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/v1/service-options-and-variants',
                destPath: '/v1/serviceOptionsAndVariants',
            },
            {
                srcPath: '/_api/v1/serviceOptionsAndVariants',
                destPath: '/v1/serviceOptionsAndVariants',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/v1/service-options-and-variants',
                destPath: '/v1/serviceOptionsAndVariants',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/v1/service-options-and-variants',
                destPath: '/v1/serviceOptionsAndVariants',
            },
            {
                srcPath: '/_api/bookings/v1/service-options-and-variants',
                destPath: '/api',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/v1/service-options-and-variants',
                destPath: '/v1/serviceOptionsAndVariants',
            },
            {
                srcPath: '/_api/bookings/v1/service-options-and-variants',
                destPath: '/api',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/v1/service-options-and-variants',
                destPath: '/v1/serviceOptionsAndVariants',
            },
            {
                srcPath: '/_api/bookings/v1/service-options-and-variants',
                destPath: '/api',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/bookings/v1/serviceOptionsAndVariants',
                destPath: '/v1/serviceOptionsAndVariants',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/v1/service-options-and-variants',
                destPath: '/v1/serviceOptionsAndVariants',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/v1/service-options-and-variants',
                destPath: '/v1/serviceOptionsAndVariants',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/v1/service-options-and-variants',
                destPath: '/v1/serviceOptionsAndVariants',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Creates a `serviceOptionsAndVariants` object and for a service.
 *
 *
 * ## Calculate variants
 *
 * Before creating a `serviceOptionsAndVariants` object, you need to
 * anticipate and manually define all its variants, since Wix Bookings doesn't
 * automatically calculate them. For the actual
 * Create Service Options And Variants* call, specify both the `options` and
 * `variants` arrays.
 *
 * ## Limitations
 *
 * Wix Bookings allows you to connect only a single `serviceOptionsAndVariants`
 * object to a service. *Create Service Options And Variants* fails, if the
 * service already has a connected `serviceOptionsAndVariants` object.
 *
 * Currently, you can include only a single option per
 * `serviceOptionsAndVariants` object. Taken together, this means that services
 * are limited to a single option.
 *
 * ## Option ID
 *
 * When creating a`serviceOptionsAndVariants` object, you must specify an ID in
 * [UUID format](https://en.wikipedia.org/wiki/Universally_unique_identifier)
 * for its only option. You must reference this option ID for each variant as
 * `variants.values.choices.optionId`.
 *
 * ## Staff member option
 *
 * To creating an option based on the *staff member*
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/staff-members/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/staff-members/introduction))
 * providing the service, you need to specify `STAFF_MEMBER` as `options.values.type`.
 * Also, specify all staff member IDs as `variants.values.choices.staffMemberId`.
 * You could follow this *sample flow*
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/service-options-and-variants/sample-flows#create-staff-member-based-service-variants) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/service-options-and-variants/sample-flows#create-staff-member-based-service-variants)).
 *
 * ## Custom option
 *
 * To create an option based on a custom parameter, specify `CUSTOM` as
 * `options.values.type`. Provide descriptive names for all custom choices as
 * `variants.values.choices.custom`. These names are displayed to customers
 * during the book flow. You could follow this *sample flow*
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/service-options-and-variants/sample-flows#create-service-variants-based-on-the-booked-equipment) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/service-options-and-variants/sample-flows#create-service-variants-based-on-the-booked-equipment)).
 *
 * ## Duration option
 *
 * To create an option based on appointment duration, specify `DURATION` as
 * `options.values.type` and set a descriptive name in `options.values.durationData.name`.
 * Also, indicate the appointment length in `minutes` and provide a descriptive
 * `name` for each duration choice in `variants.values.choices.duration`.
 */
export function createServiceOptionsAndVariants(payload) {
    var _a = serializer(_createServiceOptionsAndVariantsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createServiceOptionsAndVariantsResponse, {}).fromJSON;
    function __createServiceOptionsAndVariants(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.catalog.v1.service_options_and_variants',
            method: 'POST',
            methodFqn: 'wix.bookings.catalog.v1.ServiceOptionsAndVariantsService.CreateServiceOptionsAndVariants',
            url: resolveWixBookingsCatalogV1ServiceOptionsAndVariantsServiceUrl({
                protoPath: '/v1/serviceOptionsAndVariants',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createServiceOptionsAndVariants.fromReq = fromReq;
    __createServiceOptionsAndVariants.__isAmbassador = true;
    return __createServiceOptionsAndVariants;
}
/**
 * Clones a `serviceOptionsAndVariants` object and connects it to a *service*
 * ([SDK](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/introduction) | [REST](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/introduction)).
 *
 *
 * The call fails if the service already has a connected
 * `serviceOptionsAndVariants` object.
 *
 * The cloned `serviceOptionsAndVariants` object gets a new, unique option ID.
 * The option ID of the existing `serviceOptionsAndVariants` object isn't reused.
 *
 * For example, you may call this method after *cloning a service*
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/clone-service) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/clone-service)).
 */
export function cloneServiceOptionsAndVariants(payload) {
    var _a = serializer(_cloneServiceOptionsAndVariantsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cloneServiceOptionsAndVariantsResponse, {}).fromJSON;
    function __cloneServiceOptionsAndVariants(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.catalog.v1.service_options_and_variants',
            method: 'POST',
            methodFqn: 'wix.bookings.catalog.v1.ServiceOptionsAndVariantsService.CloneServiceOptionsAndVariants',
            url: resolveWixBookingsCatalogV1ServiceOptionsAndVariantsServiceUrl({
                protoPath: '/v1/serviceOptionsAndVariants/{cloneFromId}/clone',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cloneServiceOptionsAndVariants.fromReq = fromReq;
    __cloneServiceOptionsAndVariants.__isAmbassador = true;
    return __cloneServiceOptionsAndVariants;
}
/** Retrieves a `serviceOptionsAndVariants` object by its ID. */
export function getServiceOptionsAndVariants(payload) {
    var _a = serializer(_getServiceOptionsAndVariantsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getServiceOptionsAndVariantsResponse, {}).fromJSON;
    function __getServiceOptionsAndVariants(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.catalog.v1.service_options_and_variants',
            method: 'GET',
            methodFqn: 'wix.bookings.catalog.v1.ServiceOptionsAndVariantsService.GetServiceOptionsAndVariants',
            url: resolveWixBookingsCatalogV1ServiceOptionsAndVariantsServiceUrl({
                protoPath: '/v1/serviceOptionsAndVariants/{serviceOptionsAndVariantsId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveWixBookingsCatalogV1ServiceOptionsAndVariantsServiceUrl({
                        protoPath: '/v1/serviceOptionsAndVariants/{serviceOptionsAndVariantsId}',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __getServiceOptionsAndVariants.fromReq = fromReq;
    __getServiceOptionsAndVariants.__isAmbassador = true;
    return __getServiceOptionsAndVariants;
}
/**
 * Retrieves a `serviceOptionsAndVariants` object by *service ID*
 * ([SDK](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/introduction) | [REST](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/introduction)).
 */
export function getServiceOptionsAndVariantsByServiceId(payload) {
    var _a = serializer(_getServiceOptionsAndVariantsByServiceIdRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getServiceOptionsAndVariantsByServiceIdResponse, {}).fromJSON;
    function __getServiceOptionsAndVariantsByServiceId(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.catalog.v1.service_options_and_variants',
            method: 'GET',
            methodFqn: 'wix.bookings.catalog.v1.ServiceOptionsAndVariantsService.GetServiceOptionsAndVariantsByServiceId',
            url: resolveWixBookingsCatalogV1ServiceOptionsAndVariantsServiceUrl({
                protoPath: '/v1/serviceOptionsAndVariants/service_id/{serviceId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveWixBookingsCatalogV1ServiceOptionsAndVariantsServiceUrl({
                        protoPath: '/v1/serviceOptionsAndVariants/service_id/{serviceId}',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __getServiceOptionsAndVariantsByServiceId.fromReq = fromReq;
    __getServiceOptionsAndVariantsByServiceId.__isAmbassador = true;
    return __getServiceOptionsAndVariantsByServiceId;
}
/**
 * Updates a `serviceOptionsAndVariants` object.
 *
 *
 * Currently, only a single option is supported per `serviceOptionsAndVariants` object.
 *
 * If you want to update `variants`, you must pass the entire list of supported
 * variants, not only newly added variants.
 *
 * If you want to update `options`, you must pass the entire list of supported
 * options, not only newly added options.
 */
export function updateServiceOptionsAndVariants(payload) {
    var _a = serializer(_updateServiceOptionsAndVariantsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateServiceOptionsAndVariantsResponse, {}).fromJSON;
    function __updateServiceOptionsAndVariants(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.catalog.v1.service_options_and_variants',
            method: 'PATCH',
            methodFqn: 'wix.bookings.catalog.v1.ServiceOptionsAndVariantsService.UpdateServiceOptionsAndVariants',
            url: resolveWixBookingsCatalogV1ServiceOptionsAndVariantsServiceUrl({
                protoPath: '/v1/serviceOptionsAndVariants/{serviceOptionsAndVariants.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateServiceOptionsAndVariants.fromReq = fromReq;
    __updateServiceOptionsAndVariants.__isAmbassador = true;
    return __updateServiceOptionsAndVariants;
}
/**
 * Deletes a `serviceOptionsAndVariants` object.
 *
 *
 * Because each service can be connected to only a single `serviceOptionsAndVariants`
 * object, the service doesn't support *varied pricing*
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/about-service-payments) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/about-service-payments#service-rates))
 * after deleting a `serviceOptionsAndVariants` object. Instead, Wix Bookings
 * uses its standard price calculation.
 */
export function deleteServiceOptionsAndVariants(payload) {
    var _a = serializer(_deleteServiceOptionsAndVariantsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteServiceOptionsAndVariantsResponse, {}).fromJSON;
    function __deleteServiceOptionsAndVariants(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.catalog.v1.service_options_and_variants',
            method: 'DELETE',
            methodFqn: 'wix.bookings.catalog.v1.ServiceOptionsAndVariantsService.DeleteServiceOptionsAndVariants',
            url: resolveWixBookingsCatalogV1ServiceOptionsAndVariantsServiceUrl({
                protoPath: '/v1/serviceOptionsAndVariants/{serviceOptionsAndVariantsId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteServiceOptionsAndVariants.fromReq = fromReq;
    __deleteServiceOptionsAndVariants.__isAmbassador = true;
    return __deleteServiceOptionsAndVariants;
}
/**
 * Retrieves a list of `serviceOptionsAndVariants` objects, given the provided
 * paging, filtering, and sorting.
 *
 *
 * Query Service Options And Variants* runs with these defaults, which you can override:
 *
 * - `id` sorted in `ASC` order.
 * - `cursorPaging.limit` set to `100`.
 *
 * For a detailed list of supported filtering operations refer to the *supported filters article*
 * ([REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/service-options-and-variants/supported-filters)).
 *
 * To learn about working with _Query_ endpoints, see
 * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language),
 * [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging),
 * and [Field Projection](https://dev.wix.com/docs/rest/articles/getting-started/field-projection).
 */
export function queryServiceOptionsAndVariants(payload) {
    var _a = serializer(_queryServiceOptionsAndVariantsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryServiceOptionsAndVariantsResponse, {}).fromJSON;
    function __queryServiceOptionsAndVariants(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.catalog.v1.service_options_and_variants',
            method: 'POST',
            methodFqn: 'wix.bookings.catalog.v1.ServiceOptionsAndVariantsService.QueryServiceOptionsAndVariants',
            url: resolveWixBookingsCatalogV1ServiceOptionsAndVariantsServiceUrl({
                protoPath: '/v1/serviceOptionsAndVariants/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryServiceOptionsAndVariants.fromReq = fromReq;
    __queryServiceOptionsAndVariants.__isAmbassador = true;
    return __queryServiceOptionsAndVariants;
}
//# sourceMappingURL=http.impl.js.map